import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  API_AUTH_PASSWORD,
  API_AUTH_USERNAME,
  API_BASE_URL,
} from "../Constant/Global";
import { useNavigate } from "react-router-dom";

export const useCheckAuth = () => {
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [openModal, setOpenModal] = useState(false);
  const userDetails = sessionStorage.getItem("info");
  const useInfo = JSON.parse(userDetails);

  const handleLogout = () => {
    setOpenModal(false);
    sessionStorage.removeItem("info");
    navigate("/login");
  };

  const handleGetProfileData = async () => {
    const id = useInfo.id;
    if (id != null) {
      try {
        const response = await axios.get(API_BASE_URL + `vendor/${id}`, {
          auth: {
            username: API_AUTH_USERNAME,
            password: API_AUTH_PASSWORD,
          },
        });
        if (response.data.status) {
          setStatus(response.data.data.status);
          if (response.data.data.status === "N") {
            setOpenModal(true);
          }
        }
      } catch (error) {
        console.log("error occured gettting profile data", error);
      }
    }
  };

  useEffect(() => {
    handleGetProfileData();
  }, []);

  return { status, handleGetProfileData, openModal, handleLogout };
};
